import '@apollo/client'
import { Typography } from '@material-ui/core'

import { gregorianToJalaaliWithHourMinuteAndSecond } from '../../helpers/date'
import { lang } from '../../localization'
// import { getTranslate } from '../../localization'
import { PushDetailsPerAcc } from '../../types/channelPush'
import StatusBox from './StatusBox'
import useStyles from './styles/accsTableRow.style'

interface AccsTableRowProps {
  accommodationName: string
  push: PushDetailsPerAcc
  isOdd: boolean
  getWebHookLabelByValue: (value: string) => string | undefined
}

export const AccsTableRow: React.FC<AccsTableRowProps> = ({
  accommodationName,
  push,
  isOdd,
  getWebHookLabelByValue
}) => {
  const classes = useStyles({ isOdd })

  const { adaptor, healthStatus, lastFetched, lastSent, nextTime } = push

  return (
    <div className={classes.tableRow}>
      <div className={classes.tableRowExceptMenuItem}>
        <div>
          <Typography variant="h4">{accommodationName}</Typography>
        </div>
        <div>
          <Typography variant="h4">
            {getWebHookLabelByValue(adaptor)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang == 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(lastFetched)
              : lastFetched}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang == 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(lastSent)
              : lastSent}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {lang == 'fa'
              ? gregorianToJalaaliWithHourMinuteAndSecond(nextTime)
              : nextTime}
          </Typography>
        </div>
        <div>{<StatusBox status={healthStatus} />}</div>
      </div>
    </div>
  )
}
